export default "__VITE_ASSET__CSfWbCb___"